import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Tenant } from 'src/environments/evironment.interface';
import { AuthenticationService } from 'src/shared/services/auth/auth_service';
import { ValidationService } from 'src/shared/services/validation/validation.service';
import { BannerComponent } from '../../design/banner/banner.component';
import { TitleComponent } from '../../design/title/title.component';

import { TranslateModule } from '@ngx-translate/core';
import { MixpanelService } from 'src/shared/services/mix-panel.service/mix-panel.service';
import { RightImagePageWrapperComponent } from '../../design/rightimagepagewrapper/rightimagepagewrapper.component';
import { FormSubmissionButtonComponent } from '../../forms/form-submission-button/form-submission-button.component';
import { InputComponent } from '../../forms/input/input.component';
import { ResetpasswordLinkSentComponent } from '../resetpassword-link-sent/resetpassword-link-sent.component';

@Component({
  selector: 'app-forgottenpassword',
  templateUrl: './forgottenpassword.component.html',
  imports: [
    TitleComponent,
    BannerComponent,
    RightImagePageWrapperComponent,
    InputComponent,
    ReactiveFormsModule,
    FormSubmissionButtonComponent,
    ResetpasswordLinkSentComponent,
    TranslateModule,
  ],
})
export class ForgottenPasswordComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly fb = inject(FormBuilder);
  private readonly mixpanelService = inject(MixpanelService);
  private readonly authenticationService = inject(AuthenticationService);

  ngOnInit(): void {
    this.mixpanelService.track('password.reset');
  }

  form = this.fb.group({
    email: new FormControl('', [ValidationService.validateEmail]),
  });
  loading!: boolean;
  error!: string;
  activeTenant: Tenant | undefined = this.authenticationService.getActiveTenant();
  emailsent!: boolean;

  onSubmitRegister(form: FormGroup) {
    if (!form.valid) return;
    if (this.loading) return;
    this.error = '';
    this.loading = true;
    this.authenticationService
      .sendPasswordResetEmail(form.value.email)
      .then(() => this.next())
      .catch(() => this.next())
      .finally(() => this.resetForm());
  }

  login() {
    this.router.navigate(['/login']);
  }

  next() {
    this.emailsent = true;
  }

  handlerError(error: string) {
    this.error = error;
  }

  clearError() {
    this.error = '';
  }

  resetForm() {
    this.loading = false;
  }
}
